/* eslint-disable no-param-reassign */
import React, { useState, useEffect, Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Popover, Select, Table } from 'antd';
import { CloseOutlined, InfoCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import H3FormInput from '@Uilib/h3FormInput';
import imageDefault from '@Images/icons/imageDefault.png';
import H3Image from '@Uilib/h3Image';
import ProductFilterV2 from '@Components/Common/ProductFilterV2';
import SelectUOM from '@Components/Admin/Common/SelectUOM';
import './style.scss';
import Helpers from '@Apis/helpers';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import Constants, { QUANTITY } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import QuickAddButton from '@Components/Common/UILib/QuickAddButton';
import CustomDocumentColumns from '@Components/Common/CustomDocumentColumns';
import ProductDescriptions from '../../../../Common/ProductDescriptions';
import ProductCategoryLabel from '../../../../Common/ProductCategoryLabel';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const { Option } = Select;

const PurchaseRequestLines = ({
  handleProductChangeValue, handleProductChange, customLineInputChange, visibleColumns,
  formSubmitted, data, selectedTenant, updateData, sourceDepartmentId, targetPriceMandatory,
  handleDelete, MONEY, user, cfPurchaseRequestLine, setVisibleColumns, isUpdateCase, getCartV2Loading, priceMasking, isCarryForward, mrpId, selectedPurchaseRequest, prId, handleMultiProductChange
}) => {
  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const getColumns = () => {
    const listColumns = [
      {
        title: '',
        key: 'asset1',
        fixed: 'left',
        render: (text, record) => (
          <div style={{ width: '30px' }}>
            <H3Image src={record?.asset1 || imageDefault} className="pr-table__image" style={{ opacity: record?.asset1 ? 1 : 0.1 }} />
          </div>
        ),
        width: '60px',
        visible: true,
      },
      {
        title: 'Product',
        width: '250px',
        fixed: 'left',
        render: (text, record) => (
          <div className="pr-table__product-name">
            <ProductFilterV2
              record={record}
              productTypes={['STORABLE', 'SERVICE']}
              handleProductChangeValue={handleProductChangeValue}
              handleProductChange={handleProductChange}
              isPurchaseProduct
              required
              pendingFromVendor
              showError={formSubmitted && !record.product_sku_name}
              onClear={(key) => {
                const copyData = JSON.parse(JSON.stringify(data));
                const updatedData = copyData.map((item) => {
                  if (item.key === key) {
                    return {
                      key: uuidv4(),
                      asset1: '',
                      product_sku_name: '',
                      uomGroup: null,
                      purchase_requisition_id: null,
                      product_sku_info: null,
                      product_sku_id: null,
                    };
                  }
                  return {
                    ...item,
                  };
                });
                updateData(updatedData);
              }}
              disabled={record?.product_sku_id}
              // excludedProducts={data.map((item) => JSON.stringify(item?.tenant_product_id)) || []}
              selectedTenant={selectedTenant}
              tenantDepartmentId={sourceDepartmentId}
              showClear
              enableAdvanceSearch
              handleMultiProductChange={handleMultiProductChange}
            />
            {record?.productCategoryInfo?.category_path?.length > 0 && (
              <ProductCategoryLabel
                categoryPath={record?.productCategoryInfo?.category_path}
                categoryName={record?.productCategoryInfo?.category_path?.at(
                  -1
                )}
                containerStyle={{
                  width: "fit-content",
                }}
              />
            )}
            {
              !record?.remarkRequired && record.product_sku_name
              && (
                <QuickAddButton
                  label="Add Description"
                  onClick={() => {
                    const copyData = JSON.parse(JSON.stringify(data));
                    const newData = copyData.map((item) => {
                      if (item.key === record.key) {
                        return { ...item, remarkRequired: !record?.remarkRequired };
                      }
                      return item;
                    });
                    if (JSON.stringify(data) !== JSON.stringify(newData)) {
                      updateData(newData);
                    }
                  }}
                />
              )
            }
            {record?.remarkRequired ? (
              <ProductDescriptions
                descriptions={record?.remark}
                modules={{
                  toolbar: false,
                }}
                onChange={(e) => {
                  const copyData = JSON.parse(JSON.stringify(data));
                  const newData = copyData.map((item) => {
                    if (item.key === record.key) {
                      return { ...item, remark: e, remarkRequired: !!e?.replace(/<[^>]+>/g, '') };
                    }
                    return item;
                  });

                  if (JSON.stringify(data) !== JSON.stringify(newData)) {
                    updateData(newData);
                  }
                }}
                className="invoice-table__remarks"
                placeholder="Add description of this item.."
                key={record.key}
              />
            ) : ''}
          </div>
        ),
        visible: visibleColumns?.PRODUCT?.visible,
      },
      {
        title: 'Available Qty',
        width: '150px',
        render: (text, record) => {
          const uomInfo = record?.uom_info;
          const uomList = record?.uom_list;
          const filteredDepartmentsStock = record?.otherDepartmentStock?.filter((item) => item?.tenant_department_id !== sourceDepartmentId);
          const currentDepartmentStock = record?.otherDepartmentStock?.find((item) => item?.tenant_department_id === sourceDepartmentId) || 0;
          const totalStockInOtherDepartments = filteredDepartmentsStock?.map((dept) => dept?.quantity).reduce((acc, cur) => acc + cur, 0);
          const totalPendingFromVendor = record?.pos_quantity_against_product?.map((quantity) => {
            const difference = quantity.total_pending_quantity - quantity.total_received_quantity;
            return difference;
          }).reduce((acc, cur) => acc + cur, 0);
          const hoverContentForPendingFromVendor = (
            <div>
              {record?.pos_quantity_against_product
                ?.filter((vendors) => vendors.total_pending_quantity - vendors.total_received_quantity > 0)
                ?.map((vendors) => (
                  <div
                    key={vendors.seller_id}
                    className="other-uom-stock"
                    onClick={() => {
                      window.open(`/purchase/purchase-orders?page=1&limit=10&tenant=${selectedTenant}&status=ISSUED&keyword=${vendors?.seller_name}&po_receiving_status=PARTIALLY_RECEIVED,NOT_RECEIVED&product_search_from_pr=${record?.product_sku_id}&product_prefill=true `);
                    }}
                    style={{
                      cursor: 'pointer',
                    }}
                  >
                    <Link target="_blank" className="ellipsis">
                      {`${vendors?.internal_slr_code} - ${vendors?.seller_name?.toProperCase()}`}
                    </Link>
                    <H3Text
                      text={`${QUANTITY(vendors?.total_pending_quantity - vendors?.total_received_quantity) || 0} ${record?.uom_info?.uqc?.toProperCase()}`}
                      className="tenant-inventory-slider__dept-qty"
                    />
                  </div>
                ))}
            </div>
          );
          const quantityInDiffUoms = (
            <div>
              {
                uomList?.map((uom, i) => (
                  <div className="other-uom-stock" key={i}>
                    <div>
                      {QUANTITY((Number(currentDepartmentStock?.quantity || record?.currentDepStock || 0) * uomInfo?.ratio) / uom?.ratio, uom?.precision)}
                    </div>
                    <div>
                      {uom?.uqc?.toProperCase()}
                    </div>
                  </div>
                ))
              }
            </div>
          );
          const hoverContent = (
            <div>
              {filteredDepartmentsStock?.map((dept) => (
                <div key={dept.department_id} className="other-uom-stock">
                  <H3Text text={dept?.alias_name} />
                  <H3Text
                    text={`${QUANTITY(dept?.quantity)} ${record?.uom_info?.uqc?.toProperCase()}`}
                    className="tenant-inventory-slider__dept-qty"
                  />
                </div>
              ))}
            </div>
          );
          return (
            <div>
              <Popover
                placement="bottom"
                content={quantityInDiffUoms}
                title="Quantity in other units"
                trigger="hover"
              >
                <div style={{ cursor: 'pointer' }}>
                  {`${currentDepartmentStock?.quantity || record?.currentDepStock || 0} ${record?.uom_info?.uqc?.toProperCase() || ''}`}
                </div>
              </Popover>
              {totalStockInOtherDepartments > 0 && (
                <Popover
                  placement="bottom"
                  title="Stocks in other locations"
                  content={hoverContent}
                  trigger="hover"
                >
                  <div
                    className="table-subscript"
                    style={{
                      color: 'rgb(109 107 106)',
                    }}
                  >
                    {`+${QUANTITY(totalStockInOtherDepartments, record?.uom_info?.precision)}  ${record?.uom_info?.uqc?.toProperCase() || ''} in other locations`}
                    <InfoCircleOutlined style={{
                      color: 'rgb(45, 124, 246)',
                      margin: '2px',
                    }}
                    />
                  </div>
                </Popover>
              )}
              {totalPendingFromVendor > 0 && (
                <Popover
                  placement="bottom"
                  title="Pending from vendors"
                  content={hoverContentForPendingFromVendor}
                  trigger="hover"
                >
                  <div
                    className="table-subscript"
                    style={{
                      color: 'rgb(109 107 106)',
                    }}
                  >
                    {`+${QUANTITY(totalPendingFromVendor, record?.uom_info?.precision)}  ${record?.uom_info?.uqc?.toProperCase() || ''} pending from vendors`}
                    <InfoCircleOutlined style={{
                      color: 'rgb(45, 124, 246)',
                      margin: '2px',
                    }}
                    />
                  </div>
                </Popover>
              )}
            </div>
          );
        },
        visible: visibleColumns?.AVAILABLE_QTY?.visible && isUpdateCase,
      },
      {
        title: 'Quantity',
        width: '120px',
        render: (text, record) => (
          <div>
            <H3FormInput
              value={record.quantity}
              type="number"
              containerClassName={`orgInputContainer ${(formSubmitted && Number(record.quantity) <= 0) ? 'create-pr__input' : ''}`}
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              onChange={(e) => {
                CustomFieldHelpers.updateCustomColumnValue(Number(e.target.value || 0), record.lineCustomFields?.find((i) => i?.fieldName === 'Quantity'), record.lineCustomFields, (value) => customLineInputChange(value, record?.key));
              }}
              disabled={(mrpId || selectedPurchaseRequest?.mrp_id || selectedPurchaseRequest?.mo_id) && !prId && !user?.tenant_info?.permission?.editable_material_request_qty_from_mrp}
            />
            {formSubmitted && (!record.quantity || Number(record.quantity || '0') < 0) && <div className="input-error">*Please enter quantity</div>}
          </div>
        ),
        visible: visibleColumns?.QUANTITY?.visible,
      },
      {
        title: 'Unit',
        width: '120px',
        render: (text, record) => (
          <div style={{ width: '120px' }}>
            {record?.tenant_product_id ? (
              <div className="orgInputContainer">
                <PRZSelect
                  dropdownAlign={{ offset: [-6, 4] }}
                  filterOption={false}
                  className=""
                  value={record?.uomId}
                  onChange={(value) => {
                    const copyData = JSON.parse(JSON.stringify(data));
                    copyData.map((item) => {
                      if (item.key === record.key) {
                        item.uomId = value;
                        item.uom_info = item?.uom_list?.find((rec) => rec?.uom_id === value);
                      }
                      return item;
                    });
                    updateData(copyData);
                  }}
                >
                  {
                    record?.uom_list?.map((uom) => (
                      <Option key={uom?.uom_id} value={uom?.uom_id}>{`${uom?.uqc?.toProperCase()} (${uom?.uom_name?.toProperCase()})`}</Option>
                    ))
                  }
                </PRZSelect>
              </div>
            ) : (
              <div className="orgInputContainer">
                <SelectUOM
                  onChange={(value) => {
                    const copyData = JSON.parse(JSON.stringify(data));
                    copyData.map((item) => {
                      if (item.key === record.key) {
                        item.uom_id = value?.uom_id;
                        item.uom_info = value;
                      }
                      return item;
                    });
                    updateData(copyData);
                  }}
                  errorOutline={formSubmitted && !record?.uom_id}
                  selectedUom={record.uom_id}
                  hideTitle
                  uomGroup={record.uomGroup}
                  customStyle={{
                    width: '120px',
                  }}
                />
              </div>
            )}
          </div>
        ),
        visible: visibleColumns?.UNIT_PRICE?.visible,
      },
      {
        title: 'Target Price',
        width: '120px',
        render: (text, record) => (
          <div>
            <H3FormInput
              value={record.targetPrice}
              type="number"
              containerClassName={`orgInputContainer ${(formSubmitted && targetPriceMandatory && Number(record.targetPrice || 0) <= 0) ? 'create-pr__input' : ''}`}
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              onChange={(e) => {
                const copyData = JSON.parse(JSON.stringify(data));
                copyData.map((item) => {
                  if (item.key === record.key) {
                    item.targetPrice = e.target.value;
                  }
                  return data;
                });
                updateData(copyData);
              }}
              hideInput={isDataMaskingPolicyEnable && isHideCostPrice}
              popOverMessage={"You don't have access to view target price"}
            />
            <div className="table-inline-description">
              {!(isDataMaskingPolicyEnable && isHideCostPrice) && targetPriceMandatory && (
                <React.Fragment>
                  {record.maxPrice ? (
                    <div className="table-subscript">
                      Max Purchase Price :
                      {'  '}
                      {MONEY(record.maxPrice || 0)}
                    </div>
                  ) : ''}
                  {record.minPrice ? (
                    <div className="table-subscript">
                      Min Purchase Price :
                      {'  '}
                      {MONEY(record.minPrice || 0)}
                    </div>
                  ) : ''}
                  {record.avaragePrice ? (
                    <div className="table-subscript">
                      Avg Purchase Price :
                      {'  '}
                      {MONEY(record.avaragePrice || 0)}
                    </div>
                  ) : ''}
                </React.Fragment>
              )}
            </div>
            {!(isDataMaskingPolicyEnable && isHideCostPrice) && formSubmitted && targetPriceMandatory && !record.targetPrice && <div className="input-error">*Please enter target price</div>}
          </div>
        ),
        visible: visibleColumns?.TARGET_PRICE?.visible,
      },
      {
        title: '',
        render: (text, record) => (
          <Fragment>
            {data.length !== record.key && (
              <div className="update-pr__delete-line-button" onClick={() => handleDelete(record.key)}>
                <CloseOutlined />
              </div>
            )}
          </Fragment>
        ),
        width: '40px',
        visible: true,
        fixed: 'right',
      },
    ];
    if (cfPurchaseRequestLine?.length) {
      listColumns.splice(3, 0, ...CustomFieldHelpers.renderCustomLineColumns(false, cfPurchaseRequestLine, visibleColumns, customLineInputChange, formSubmitted, '', '', '', '', '', '', '', isCarryForward));
    }

    return listColumns.filter((item) => item.visible);
  };

  const getDataSource = (newData) => JSON.parse(JSON.stringify(newData));

  return (
    <Fragment>
      <Table
        bordered
        showHeader
        size="small"
        scroll={{ x: 'max-content' }}
        columns={getColumns()}
        dataSource={getDataSource(data)}
        pagination={false}
        title={() => (
          <div className="pr-table__header">
            <H3Text
              text={`Material Request Items (${data?.filter(
                (item) => item.product_sku_name?.length > 0,
              )?.length
                })`}
              className="form__input-row__label"
            />
            <div style={{ marginLeft: '5px' }}>
              <CustomDocumentColumns
                visibleColumns={visibleColumns || []}
                setVisibleColumns={(dt) => setVisibleColumns(dt)}
                customColumns={cfPurchaseRequestLine || []}
                data={data}
                updateData={(updatedData) => updateData(updatedData)}
              />
            </div>
          </div>
        )}
        loading={getCartV2Loading}
      />
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, CFV2Reducers, AddToCartReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getCartV2Loading: AddToCartReducers.getCartV2Loading,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
});

PurchaseRequestLines.propTypes = {
  handleProductChangeValue: PropTypes.func,
  handleProductChange: PropTypes.func,
  handleDelete: PropTypes.func,
  updateData: PropTypes.func,
  data: PropTypes.any,
  formSubmitted: PropTypes.bool,
  targetPriceMandatory: PropTypes.bool,
  selectedTenant: PropTypes.any,
  sourceDepartmentId: PropTypes.any,
  user: PropTypes.any,
  MONEY: PropTypes.any,
  customLineInputChange: PropTypes.func,
  visibleColumns: PropTypes.any,
  cfPurchaseRequestLine: PropTypes.any,
  setVisibleColumns: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseRequestLines));
